export default theme => ({
  tableCellRoot: {
    padding: "4px 8px",
    color: "#000"
  },
  tableCellColor: {
    color: "#000"
  }
});
